<template>
  <router-view />
</template>

<route>
{
  "redirect": "/profile/security",
  "name": "Profile"
}
</route>

<script>
import { mapActions } from "vuex";
export default {
  layout: "userprofile",
  methods: mapActions("pageMeta", ["setPageTitle"]),
  created() {
    this.setPageTitle(this.$t("Profile"));
  },
};
</script>
